import { Alert, Avatar, Button, CircularProgress, Grid, IconButton, InputAdornment, Paper, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { AccountCircle, LockOutlined, Visibility, VisibilityOff } from '@mui/icons-material';
import { useContext, useState, useEffect } from 'react';
import { AuthContext } from '../../../Context/AuthContext';
import { green } from '@mui/material/colors';
import { getAppVersion } from '../../../Config';


const Login = () => {

    const { updateIsLogin, getTokenApi } = useContext(AuthContext);

    const [errorLogin, setErrorLogin] = useState('')
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [appVersion, setAppVersion] = useState('Cargando...');

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };

    useEffect(() => {
        const fetchVersion = async () => {
          const version = await getAppVersion();
          setAppVersion(version);
        };
    
        fetchVersion();
      }, []);

    const avatarStyle = { backgroundColor: '#31a131' }

    const solicitarToken = async (user, pass) => {

        updateIsLogin(false);
        setErrorLogin('');
        setIsLoading(true);

        /*le doy una demora de 2 seg*/
        setTimeout(() => {

            getTokenApi(user, pass)
                .then((data) => {
                    if (data.access_token) {
                        updateIsLogin(true); // si se loguea correctamente
                    }
                    else {
                        setErrorLogin(JSON.parse(data.error).Msj);
                    }
                })
                .catch((error) => console.log('error', error))
                .finally(() => setIsLoading(false))

        }, 2000);
    }

    const onAceptar = (e) => {
        e.preventDefault();
        const formData = new FormData(e.currentTarget);

        const user = formData.get("user")
        const pass = formData.get("pass")

        solicitarToken(user, pass)

    }

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#e9e9e9',
                minHeight: '100vh',
                overflow: 'hidden',
                px: 4, // Agrega un espacio horizontal de 4
                py: 8 // Agrega un espacio vertical de 8
            }}
        >
            <Paper elevation={5} sx={{ borderRadius: 3 }}>
                <Grid container style={{ minHeight: '40vh' }}>
                    <Grid item xs={12} sm={6}>
                        <img src="img/ondas-split.png" style={{ width: '100%', height: '100%', backgroundColor: '#00A7DB', objectFit: 'cover', borderRadius: '10px 0 0 10px' }} alt="primary" />
                    </Grid>
                    <Grid container item xs={12} sm={6} alignItems="center" direction="column" justify="space-beetwen" style={{ padding: 10, paddingBottom: '70px', position: 'relative' }} align="center">

                        <Box sx={{ display: 'flex', flexDirection: 'column', maxWidth: 500, minWidth: 300 }}>
                            <Grid align="center">
                                {/* <Typography variant="h5" gutterBottom>Inicio de sesión</Typography> */}
                                <img src="img/esco-bolsa-azul.png" width={200} alt="esco bolsa" />
                                <Avatar style={avatarStyle}><LockOutlined /></Avatar>
                            </Grid>

                            <Box component={'form'} onSubmit={onAceptar} sx={{ display: 'flex', flexDirection: 'column', maxWidth: 300, minWidth: 300 }}>
                                <TextField
                                    label="Usuario"
                                    name="user"
                                    margin='normal'
                                    onChange={() => setErrorLogin('')}
                                    required
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <AccountCircle />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <TextField
                                    label="Contraseña"
                                    name="pass"
                                    type={showPassword ? 'text' : 'password'}
                                    margin='normal'
                                    onChange={() => setErrorLogin('')}
                                    required
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <LockOutlined />
                                            </InputAdornment>
                                        ),
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton onClick={handleTogglePassword}>
                                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <Button disabled={isLoading} color="primary" type="submit" variant="contained" sx={{ mt: 4 }} aria-label="Iniciar sesión">Iniciar sesión</Button>
                                    {errorLogin && <Alert severity="error" sx={{ mt: 2, minWidth: '100%' }}>{errorLogin}</Alert>}
                                    {isLoading && (
                                        <CircularProgress
                                            size={24}
                                            sx={{
                                                color: green[500],
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                marginTop: '-12px',
                                                marginLeft: '-12px',
                                            }}
                                        />
                                    )}
                                </Box>
                            </ Box>

                        </Box>

                        <Box sx={{ backgroundColor: 'black', position: 'absolute', bottom: 0, width: '100%', opacity: 0.4, color: 'white', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', borderRadius: '0 0 10px 0' }}>
                            <Typography> Año 2025 -  </Typography>
                            <img src='./img/primary-logo-blanco-horizontal.png' style={{ width: '150px', height: '43px', justifyContent: 'center' }} alt='Primary blanco' />
                            <Typography> - Versión {appVersion} </Typography>
                        </Box>

                    </Grid>
                </Grid>
            </Paper>
        </Box>

    );
};

export default Login;